export default __webpack_public_path__ + "static/media/us_2.5eda85b0.mp3";